@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.seller-provider-list-item {
  border: 1px solid @rate-viewer-seller-provider-list-item--border-color;
  border-radius: 4px;
  opacity: 0.5;
  background: @rate-viewer-seller-provider-list-item--background-color;
  display: flex;
  padding: 10px;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  text-align: left;
  position: relative;

  &:hover {
    background: @rate-viewer-seller-provider-list-item--hover--background-color;
  }

  &.has-rates {
    opacity: 1;
    .count {
      background: @rate-viewer-seller-provider-list-item--count--has-rates--background-color;
    }
  }

  &.selected {
    background: @rate-viewer-seller-provider-list-item--selected--background-color;

    &:after {
      content: '';
      position: absolute;
      inset: -1px;
      border: 2px solid @rate-viewer-seller-provider-list-item--selected--border-color;
      border-radius: 4px;
    }
  }

  > * {
    position: relative;
    z-index: 2;
  }
}

.logo-wrapper {
  width: 30px;
  margin-right: 10px;

  > img,
  > svg {
    height: 30px;
    width: 30px;
  }
}

.name {
  font-size: 13px;
  line-height: 16px;
  color: @rate-viewer-seller-provider-list-item--name--text-color;
  flex: auto;
  max-width: 70px;
  .truncate();
}

.count {
  font-size: 12px;
  line-height: 12px;
  padding: 5px;
  color: @rate-viewer-seller-provider-list-item--count--text-color;
  background: @rate-viewer-seller-provider-list-item--count--background-color;
  margin-left: 10px;
  border-radius: 4px;
}

.loading-indicator-wrapper {
  width: 30px;
  min-width: 30px;
  height: 30px;
  margin-left: 10px;
}
